import * as tslib_1 from "tslib";
import * as i0 from "@angular/core";
import * as i1 from "./request.service";
export class VideoService {
    constructor(requestService) {
        this.requestService = requestService;
    }
    addVideo(areaId, dto) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let data = {
                plantingSiteAreaId: areaId,
                title: dto.title,
                videoUrl: dto.videoUrl,
                description: dto.description,
                date: dto.date
            };
            let result = yield this.requestService.post('videos', data);
            return result.data;
        });
    }
    updateVideo(dto) {
        return this.requestService.patch('videos', dto);
    }
    deleteVideo(videoId) {
        return this.requestService.delete(`videos/${videoId}`);
    }
}
VideoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VideoService_Factory() { return new VideoService(i0.ɵɵinject(i1.RequestService)); }, token: VideoService, providedIn: "root" });
